import { useState } from 'react';
import { Button } from 'primereact/button';
import { HighlightSegment } from '@/api/domains/analyses/types';
import styles from './HighlightBlock.module.css';

interface HighlightBlockProps {
  segment: HighlightSegment;
}

export const HighlightBlock = ({ segment }: HighlightBlockProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasContextBefore =
    segment.context_before && segment.context_before.trim().length > 0;
  const hasContextAfter =
    segment.context_after && segment.context_after.trim().length > 0;
  const hasContext = hasContextBefore || hasContextAfter;

  return (
    <div className={styles.highlightBlock}>
      {hasContext && (
        <div className={styles.contextHeader}>
          <Button
            label={
              isExpanded
                ? 'Hide surrounding context'
                : 'Show surrounding context'
            }
            icon={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}
            onClick={() => setIsExpanded(!isExpanded)}
            className={styles.contextToggle}
            text
            size="small"
          />
        </div>
      )}

      {isExpanded && hasContextBefore && (
        <div className={styles.contextBefore}>
          <div className={styles.contextLabel}>
            <i className="pi pi-angle-double-up" />
            Context before
          </div>
          <div className={styles.contextText}>{segment.context_before}</div>
        </div>
      )}

      <div className={styles.highlightedText}>
        <div className={styles.highlightIndicator} />
        <div className={styles.highlightContent}>{segment.text}</div>
      </div>

      {isExpanded && hasContextAfter && (
        <div className={styles.contextAfter}>
          <div className={styles.contextLabel}>
            <i className="pi pi-angle-double-down" />
            Context after
          </div>
          <div className={styles.contextText}>{segment.context_after}</div>
        </div>
      )}
    </div>
  );
};
